import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { isMobileOnly } from 'react-device-detect';
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { savePDF } from '@progress/kendo-react-pdf';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import Notification from 'rc-notification';
import SmallLoader from '../../../shared/components/SmallLoader';
import { RTLProps } from '../../../shared/prop-types/ReducerProps';
import { getPromotionsForPrimeData, handleLoader } from '../../../redux/actions/PromotionsForPrimeAction';
import PromotionPrimeBarChart from './PromotionPrimeBarChart';
import PromotionPrimeTable from './PromotionPrimeTable';
import ViewSalesReportModal from '../SalesCategoryByDay/ViewSalesReportModal';
import { setCurrencyFormat } from '../../../utils/helpers';
import {
    tablePromotionPrime as tableHeaderData
} from '../helper';

const Promotions = ({ dispatch, rtl }) => {

    const location = useLocation();

    const { promotionsForPrimeData, salesChannelFilterData, isLoading } = useSelector(
        ({ promotionsForPrimeReducer, marketPlaceReducer }) =>
        ({
            promotionsForPrimeData: promotionsForPrimeReducer.promotionsForPrimeData,
            salesChannelFilterData: marketPlaceReducer.salesChannel,
            isLoading: promotionsForPrimeReducer.isLoading
        })
    );

    const previousMonthDate = new Date();
    previousMonthDate.setMonth(previousMonthDate.getMonth() - 1)

    const [dataToShow, setDataToShow] = useState(promotionsForPrimeData?.modal?.data);
    const filtersObj = promotionsForPrimeData?.modal?.filters?.[0];
    const [selectedCountryOptions, setSelectedCountryOptions] = useState({ value: 'US', label: 'USA' });
    const [isOpen, setIsOpen] = useState(false);
    const [filterData, setFilterData] = useState({});
    const [fromDate, setFromDate] = useState(previousMonthDate);
    const [toDate, setToDate] = useState(new Date());
    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };

    const filterBasedOnFilter = (item) => {
        const filters = Object.keys(filterData);
        let flag = true
        // eslint-disable-next-line no-restricted-syntax
        for (const i of filters) {
            const filter = filterData[i];
            const filtersArray = filter?.reduce((acc, fil) => [...acc, fil?.value], []) ?? [];
            if (filtersArray?.length && !filtersArray.includes(item?.[i]?.toLowerCase())) {
                flag = false
            }
        }

        return flag
    }

    const container = React.useRef(null);
    const exportToPDF = () => {
        Notification.newInstance({}, (notification) => {
            notification.notice({
                content: 'PDF loading......',
                duration: 10,
                style: { top: 120, fontWeight: "bold" },
                maxCount: 10
            });
        });
        const dvChartF = document.getElementById('dvChartFilter');
        const dvChartV = document.getElementById('dvChartView');
        dvChartF.style.display = "none";
        dvChartV.style.display = "none";
        const element = container.current || document.body;

        savePDF(element, {
            paperSize: "auto",
            Header: "test",
            margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
            // margin: "2cm",
            // forcePageBreak: ".page-break",
            //   landscape: true,
            //  multiPage: true,
            fileName: `Virtual Bundle Sales Report ${new Date().getFullYear()}`,
        })
        dvChartF.style.display = "block";
        dvChartV.style.display = "block";
    }

    const handleApplyDate = () => {
        const intFromDate = moment(fromDate).format('YYYYMMDD');
        const intToDate = moment(toDate).format('YYYYMMDD');
        if (intToDate > intFromDate) {
            dispatch(handleLoader(true));
            dispatch(getPromotionsForPrimeData({
                fromDate: moment(fromDate).format('YYYY-MM-DD'),
                toDate: moment(toDate).format('YYYY-MM-DD')
            }));
        }
        else {
            Notification.newInstance({}, (notification) => {
                notification.notice({
                    content: 'To Date must be greater than From Date.'
                });
            });
        }
    }

    const countryCodeOptions = [];
    // eslint-disable-next-line array-callback-return
    promotionsForPrimeData?.modal?.filters?.sort((a, b) => a.sortingOrder - b.sortingOrder).map((data) => {
        data.filterData.forEach((element) => {
            countryCodeOptions.push({
                value: element.key,
                label: element.shortValue
            });
        });
    });

    const sortedCountryOptions = countryCodeOptions.sort((a, b) => a.label > b.label ? 1 : -1)
    // eslint-disable-next-line react/prop-types
    const changeFilterForCountry = (value) => {
        setSelectedCountryOptions(value)
    };

    const viewReportButton = () => (
        <div className="view-report">
            <button
                type="button"
                className="view-report btn btn-primary btn-sm"
                onClick={() => setIsOpen(true)}
            >
                View Report
            </button>
        </div>
    )

    useEffect(() => {
        dispatch(handleLoader(true));
        dispatch(getPromotionsForPrimeData({
            fromDate: moment(fromDate).format('YYYY-MM-DD'),
            toDate: moment(toDate).format('YYYY-MM-DD')
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setDataToShow(promotionsForPrimeData?.modal?.data);
    }, [promotionsForPrimeData]);

    useEffect(() => {
        const OptChennel = 'salesChannel';
        setFilterData({ ...filterData, [OptChennel]: salesChannelFilterData });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [salesChannelFilterData])

    let dataToShowForDatesSelected = promotionsForPrimeData?.modal?.data || []
        ?.filter(item => filterBasedOnFilter(item))
    if (selectedCountryOptions?.length) {
        const selected = selectedCountryOptions?.reduce((acc, item) => {
            acc[item?.value] = item.value
            return acc
        }, {})
        dataToShowForDatesSelected = dataToShowForDatesSelected.filter(item => selected[item.countryCode])
    }
    const modalData = dataToShowForDatesSelected?.map(item => ({
        ...item,
        date: item.reportDate,
        amount: setCurrencyFormat(Number(item.amount).toFixed(2), true),
        day: Number(item.day).toFixed(0),
        soldQuantity: setCurrencyFormat(Number(item.soldQuantity).toFixed(0), false),
    }));
    return (
        <Container className="dashboard">
            <Row className="compare-months">
                <Col sm="12">
                    <Card className="pb-3">
                        <CardBody className="min-w-50 p-3">
                            <div className="card__title mb-2">
                                <h5 className="bold-text card__title-center">
                                    Promotion Prime</h5>
                            </div>
                            <Row className="justify-content-space-between align-items-center">
                                <Col md="2">
                                    <div className="form__form-group mb-0">
                                        <span className="form__form-group-label">Country</span>
                                        <div className="form__form-group-field">
                                            <Select
                                                value={selectedCountryOptions}
                                                options={sortedCountryOptions}
                                                clearable={false}
                                                placeholder="Select "
                                                className="select_filter"
                                                onChange={changeFilterForCountry}
                                                classNamePrefix="react-select"
                                                isMulti
                                            />
                                        </div>
                                    </div>
                                </Col>
                                <Col sm="3" md="10">
                                    <Row className="align-items-center">
                                        <Col sm="3">
                                            <div className="form__form-group mb-0">
                                                <span className="form__form-group-label">Date</span>
                                                <div className="form__form-group-field">
                                                    <div className="date-picker">
                                                        <DatePicker
                                                            className="form__form-group-datepicker"
                                                            selected={moment(fromDate).toDate()}
                                                            showPreviousMonths
                                                            onChange={handleFromDateChange}
                                                            dateFormat="MM/dd/yyyy"
                                                            dropDownMode="select"
                                                            popperPlacement="center"
                                                            withPortal={isMobileOnly}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col sm="3">
                                            <div className="form__form-group mb-0">
                                                <span className="form__form-group-label">To Date</span>
                                                <div className="form__form-group-field">
                                                    <div className="date-picker">
                                                        <DatePicker
                                                            className="form__form-group-datepicker"
                                                            selected={moment(toDate).toDate()}
                                                            onChange={handleToDateChange}
                                                            dateFormat="MM/dd/yyyy"
                                                            dropDownMode="select"
                                                            popperPlacement="center"
                                                            withPortal={isMobileOnly}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col sm="6" style={{ top: '10px' }}>
                                            <button className="btn btn-sm btn-primary apply-date-button"
                                                type="button" onClick={handleApplyDate}>
                                                Apply</button>
                                            <button className="btn btn-sm btn-primary
                                             apply-date-button" type="button"
                                                title='Export to pdf' disabled={isLoading}
                                                onClick={exportToPDF}>Export PDF</button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <div id="divToPrint" ref={container}>
                {/* <Row className="show-categ-day-wise-sales">
                    <Col xs="12"> */}
                <Card className="pb-3 show-categ-daily-sales">
                    <CardBody>
                    <Row className="show-sales-region">
                        <Col md="12">
                            <Card>
                                <CardBody>
                                    <div className="top-location" style={{ minHeight: '400' }}>
                                        <div className="card__title row align-items-center">
                                            <h5 className="bold-text col-md-4">Promotion Prime</h5>
                                        </div>
                                        <div >
                                            {isLoading ? <div style={{ minHeight: '200px' }}
                                                className="row align-items-center justify-content-center">
                                                <SmallLoader loading={isLoading} />
                                            </div>
                                                : <PromotionPrimeBarChart
                                                dir={rtl.direction}
                                                dataToShowForDatesSelected={dataToShowForDatesSelected}
                                                height={400}
                                                title='Promotion Prime'
                                                viewReportButton={viewReportButton}
                                            />}
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                        
                    </CardBody>

                </Card>
                <Card className="pb-3">
                    <CardBody className="">
                        <Row className="show-sales-region">
                            <Col md="12">
                                <Card>
                                    <CardBody>
                                        <div className="top-location" style={{ minHeight: '400' }}>
                                            <div className="card__title row align-items-center">
                                                <h5 className="bold-text col-md-4">Promotion By Revenue</h5>
                                            </div>
                                            <div >
                                                {isLoading ? <div style={{ minHeight: '200px' }}
                                                    className="row align-items-center justify-content-center">
                                                    <SmallLoader loading={isLoading} />
                                                </div>
                                                    : <PromotionPrimeTable
                                                        dataToShowForDatesSelected={dataToShowForDatesSelected}
                                                        tableHeaderData={tableHeaderData}
                                                        categorisedBasedOn='sku'
                                                    />}
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
                {/* </Col>
                </Row> */}
            </div>
            <ViewSalesReportModal
                modalData={modalData}
                isOpen={isOpen}
                handleModal={setIsOpen}
                tableHeaderData={tableHeaderData}
                fileName='Promotion Prime Report'
                title='Promotion Prime Report'
            />
        </Container>
    );
};

Promotions.propTypes = {
    dispatch: PropTypes.func.isRequired,
    rtl: RTLProps.isRequired,
};

export default connect(state => ({
    rtl: state.rtl,
}))(Promotions);
